export default {
      id: "money-withdrawal-usage",
      viewBox: "0 0 26 32",
      url: __webpack_public_path__ + "sprite.svg#money-withdrawal",
      toString: function () {
        return this.url;
      }
    }